export default {
  // base_url: "http://datatub1:9091",
  // base_url: "https://backstageweb.datastory.com.cn",
  // base_url: "https://mediaserv.datastory.com.cn",
  // base_url: "https://symedia.datastory.com.cn",

  // 用户登陆
  login: '/security/login',
  // 注销登陆
  loginOut: '/security/loginOut',
  // 获取登陆用户的信息
  login_userInfo: '/user/getInfo',

  // 用户列表
  user_list: '/user/list',
  // 用户列表-不分页
  all_user: '/user/allList',
  // 新增用户
  add_user: '/user/add',
  // 编辑用户
  edit_user: '/user/edit',
  // 删除用户
  del_user: '/user/del',
  // 修改用户密码
  edit_pwd: '/user/editPwd',
  // 微信用户列表
  wx_list: '/user/getUserWxlist',
  // 添加微信用户
  add_wxUser: '/user/addUserWx',
  // 删除微信用户
  del_wxUser: '/user/delUserWx',
  // 编辑微信用户
  edit_wxUser: '/user/editUserWx',
  // 邮箱列表
  email_list: '/warn/EmailList',
  // 新增邮箱
  add_email: '/warn/addEmail',
  // 编辑邮箱
  edit_email: '/warn/editEmail',
  // 删除邮箱
  del_email: '/warn/delEmail',

  // 敏感词列表
  library_list: '/keywordtags/list',
  // 编辑敏感词
  edit_library: '/keywordtags/edit',
  // 新增敏感词
  add_library: '/keywordtags/add',
  // 删除敏感词
  del_library: '/keywordtags/del',

  // 公司列表
  company_list: '/company/list',
  // 公司列表（分页）
  companyList_page: '/company/findAllByPage',
  // 新增公司
  add_company: '/company/add',
  // 编辑公司
  edit_company: '/company/edit',
  // 删除公司
  del_company: '/company/del',
  // 开通热敏舆情功能
  open_heat: '/company/child/add',
  // 开启/关闭 热敏舆情功能
  edit_heat: '/company/child/Edit',
  // 邮箱服务器
  emailHost: '/warn-email-sender/emailHost',
  // 新增/编辑预警邮箱
  saveOrEdit: '/warn-email-sender/saveOrEdit',
  // 预警邮箱配置
  selectOne: '/warn-email-sender/selectOne',

  // 数量配置列表
  num_list: '/tporaryPermission/findAllByPage',
  // 删除数量配置
  del_num: '/tporaryPermission/del',
  // 编辑数量配置
  edit_num: '/tporaryPermission/edit',
  // 增加数量配置
  add_num: '/tporaryPermission/add',

  // 专题列表
  class_list: '/class/list',
  // 专题列表-不分页
  all_classList: '/class/allList',
  // 编辑专题
  edit_class: '/class/update',
  // 获取字符
  characters: '/class/characters',

  // 热榜列表
  hot_list: '/todayhotlist/todayhotlists',

  // 用户别名
  userAlias_list: '/usermap/findAllByPage',
  // 增加、编辑用户别名
  add_userAlias: '/usermap/addOrEdit',
  // 删除用户别名
  del_userAlias: '/usermap/del',

  // 用户中心信息
  user_info: '/user/userCenterInfo',

  // 热更新、app更新
  update: '/appupdate/add',
  // 热更新、app更新记录
  update_list: '/appupdate/findAllByPage',
  // 删除热更新、app更新记录
  del_update: '/appupdate/del',

  // 获取站点列表
  site_list: '/sitecatalogue/selCatalogue',
  // 站点详情
  site_det: '/sitecatalogue/detail/findAll',
  // 新增/修改站点名称
  add_siteName: '/sitecatalogue/saveOrEdit',
  // 站点详情新增/修改
  edit_siteDet: '/sitecatalogue/detail/saveOrEdit',
  // 删除站点
  del_site: '/sitecatalogue/del',
  // 【站点目录】 根据catalogueId获取信息
  site_catalog_id: '/sitecatalogue/selCatalogue',
  // 通用站点列表
  commonSite_list: '/sitecatalogue/CommonList',

  // 信源范围
  siteType: '/siteType/site',

  // 本地搜索
  search: '/localEs/search',
  // 分类统计
  byTag: '/localEs/getByTag',

  // 站点管理
  // 列表-不分页
  id_list: '/sitecatalogue/desc/selDescList',
  // 列表-分页
  idPage_list: '/sitecatalogue/desc/selByPage',
  // 添加、编辑ID
  edit_id: '/sitecatalogue/desc/saveOrEdit',
  // 删除ID
  del_id: '/sitecatalogue/desc/del',

  // 部门管理
  // 部门列表
  section_list: '/dept/findAll',
  // 新增、编辑部门
  edit_section: '/dept/saveOrEdit',
  // 删除部门
  del_section: '/dept/del',
  // 人员列表
  personnel_list: '/deptuser/findAll',
  // 新增、编辑人员
  edit_personnel: '/deptuser/saveOrEdit',
  // 删除人员
  del_personnel: '/deptuser/del',

  // 广汽关键词管理
  // 列表
  word_list: '/label/findAll',
  // 新增、编辑
  edit_word: '/label/saveOrEdit',
  // 删除
  del_word: '/label/del',
  // 关联专题列表
  rule_list: '/rulelabel/findAll',
  // 新增、编辑关联专题
  edit_topic: '/rulelabel/saveOrEdit',
  // 删除关联专题
  del_topic: '/rulelabel/del',

  // 内部用户管理
  // 微信用户列表-分页
  wxUser_list: '/user/userWxPage',
  // 账号列表
  intUser_list: '/userwxcom/selList',
  // 所有账号
  users: '/userwxcom/selComUser',
  // 增加、编辑账号
  edit_acc: '/userwxcom/addOrEdit',
  // 删除账号
  del_acc: '/userwxcom/del',
  // 批量新增编辑账号
  batch_edit: '/userwxcom/banBatchAddOrEdit',

  // app用户管理
  // app用户列表
  appUser_list: '/appconfig/findByPage',
  // 修改预警
  change_warn: '/appconfig/edit',

  // 境外网站管理
  // 网站列表
  web_list: '/foreignbrowse/selByPage',
  // 新增编辑网站
  edit_web: '/foreignbrowse/saveOrEdit',
  // 删除网站
  del_web: '/foreignbrowse/del',
  // 类别列表
  type_list: '/foreignKind/selAll',
  // 删除类别
  del_type: '/foreignKind/del',
  // 新增编辑类别
  edit_type: '/foreignKind/saveOrEdit',

  // 图片/视频识别
  // 图片识别列表
  img_list: '/ocr/list',
  // 图片Excel上传
  upLoadImg: '/ocr/import',
  // 视频识别列表
  video_list: '/video/list',
  // 文档列表
  doc_list: '/excel/list',
  // 视频Excel上传
  upLoadVideo: '/video/import',
  // 图片实时识别
  addOnline: '/ocr/addOnline/a',

  //Hbase查询
  //表名
  get_table: '/hbase/getTable',
  // 平台名称
  get_platform: '/hbase/getPlatfrom',
  // 结果
  get_result: '/hbase/getResult',

  // 更新日志
  // 查询列表
  deploy_list: '/deploy/list',
  // 修改状态
  deploy_status: '/deploy/updateStatus',
  // 修改日志
  deploy_edit: '/deploy/save',
  // 删除日志
  deploy_del: '/deploy/delete',
}



// WEBPACK FOOTER //
// ./src/http/api.js